<template>
  <div class="app-container-page" @scroll="scroll" @touchstart="ontouchstart" @touchend="ontouchend">
    <div class="navbar" :style="{background: bgColor, 'padding-top': paddingTop + 'px'}" :class="{ios:isIOS}">
      <div class="navbar-back" @click="closeWebview"></div>
      <div class="navbar-title">邀请有礼</div>
      <div class="navbar-menu" @click="openRule(true)">规则</div>
    </div>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <div class="invite-page">
        <div class="notice-icon"></div>
        <div class="bar-icon">
          <div>成功邀请1位新用户可得<span>{{ configData.coin }}</span>默往币</div>
        </div>
        <div class="bar-msg">成功邀请1位新用户可得<span>{{ configData.coin }}</span>默往币</div>

        <div class="static-num">
          <div class="row-divider"></div>
          <div class="column-divider"></div>
          <div class="invite-row">
            <div class="invite-item">
              <div class="invite-num txt"><strong>{{ staticData.today_invite_count }}</strong>人</div>
              <div class="label">今日邀请</div>
            </div>
            <div class="invite-item">
              <div class="invite-num"><img src="../../assets/image/invite/coin.svg"
                                           alt=""><strong>{{ staticData.today_earned_coin }}</strong></div>
              <div class="label">今日奖励</div>
            </div>
          </div>
          <div class="invite-row">
            <div class="invite-item">
              <div class="invite-num txt"><strong>{{ staticData.total_invite_count }}</strong>人</div>
              <div class="label">累计邀请</div>
            </div>
            <div class="invite-item">
              <div class="invite-num"><img src="../../assets/image/invite/coin.svg"
                                           alt=""><strong>{{ staticData.total_earned_coin }}</strong></div>
              <div class="label">累计奖励</div>
            </div>
          </div>
          <div class="invite-code">邀请码：{{ configData.code }}
            <div class="copy" @click="copyText($event,configData.code)">复制</div>
          </div>
        </div>

        <div class="share-step">
          <div class="item">
            <div class="img"></div>
            分享邀请链接<br>给好友或群聊
          </div>
          <div class="arrow-item">
            <div class="arrow"></div>
          </div>
          <div class="item">
            <div class="img"></div>
            好友下载默往APP<br>注册填写邀请码
          </div>
          <div class="arrow-item">
            <div class="arrow"></div>
          </div>
          <div class="item">
            <div class="img"></div>
            获得默往币 <br> 邀请奖励
          </div>

        </div>

        <div class="record-container">
          <div class="title">邀请记录</div>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text=""
            :immediate-check="false"
            :error.sync="error"
            error-text=""
            @load="onLoad"
          >
            <ul class="record-list" v-show="recordList.length">
              <li class="user-item" v-for="item of recordList">
                <div class="avatar">
                  <img :src="item.avatar || require('../../assets/image/invite/avatar.png')" alt="">
                </div>
                <div class="user-info">
                  <div class="nickname">{{ item.invitee_nickname }}</div>
                  <div class="time">注册时间：{{ formatTime(item.register_time) }}</div>
                </div>
                <div class="value">+{{ item.coin }}</div>
              </li>
            </ul>
            <div class="empty" v-show="!recordList.length && finishedLoading">
              <img src="../../assets/image/invite/empty.png" alt="">
              暂无数据
            </div>
          </van-list>
        </div>
      </div>
    </van-pull-refresh>
    <div class="share-button" @click="shareBtn" :class="{disabled: !shareData.share}">{{ shareData.msg }}</div>

    <van-overlay :show="showShare" @click="showShare = false" :z-index="99">
      <div class="share-container" @click.stop>
        <div class="title">每邀请1位好友可得<span>{{ configData.coin }}默往币</span></div>
        <div class="platform-list">
          <div class="item" v-for="item of shareList" :key="item.id" @click="shareMethods(item.id,$event)">
            <div class="icon" :style="{backgroundImage:`url(${item.icon})`}"></div>
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
        <div class="cancel-button" @click="showShare = false">取消</div>
      </div>
    </van-overlay>

    <van-overlay :show="showPaster" @click="showPaster = false" :z-index="99">

      <div class="paster-container" @click.stop>
        <div class="title"><i></i>链接已复制</div>
        <div class="content">
          默往APP下载链接：https://www.mowang
          im.com/，点击下载和我一起探索默往吧
        </div>

        <div class="platform-list paster-platform">
          <div class="item" v-for="item of shareList" :key="item.id" v-show="item.show"
               @click="openOtherToApp(item.id)">
            <div class="icon" :style="{backgroundImage:`url(${item.icon})`}"></div>
            <div class="name">{{ item.desc }}</div>
          </div>
        </div>
      </div>

    </van-overlay>

    <van-overlay :show="showQrcode" @click="showQrcode = false" :z-index="99">

      <div class="qrcode-container" @click.stop>
        <div class="title">分享二维码</div>
        <div class="qrcode-wrap" id="qrcodeImg">
          <img src="../../assets/image/invite/qrcode-bg.png" alt="">
          <div class="qrcode">
            <img src="../../assets/image/invite/qrcode.png" alt="">
          </div>
        </div>
        <div class="save-button" @click="saveImage">保存图片</div>
        <i class="close" @click="showQrcode = false"></i>
      </div>

    </van-overlay>

    <transition name="van-slide-right">
      <div class="rule-page" v-show="showRule">
        <div class="navbar" :style="{ 'padding-top': paddingTop + 'px'}" :class="{ios:isIOS}">
          <div class="navbar-back" @click="openRule(false)"></div>
          <div class="navbar-title">邀请规则</div>
          <div class="navbar-menu">规则</div>
        </div>
        <div class="rule-container" v-html="configData.rule"
             :style="{'padding-top': `calc(1.33333rem + ${paddingTop}px )`}" :class="{ios:isIOS}"></div>
      </div>
    </transition>

  </div>
</template>

<script>
import inviteApi from '@/api/invite'
import NativeBridge from '@/utils/NativeBridge'
import handleClipboard from '@/utils/clipboard'
import { Toast } from 'vant'
import html2canvas from 'html2canvas'

export default {
  data () {
    return {
      showShare: false,
      showPaster: false,
      showQrcode: false,
      showRule: false,
      refreshLoading: false,
      loading: false,
      error: false,
      finished: false,
      finishedLoading: false,
      nativeBridge: new NativeBridge(),
      paddingTop: 0,
      isIOS: !!window.webkit,
      shareList: [
        {
          id: 1,
          icon: require('../../assets/image/invite/wechat.png'),
          name: '微信好友',
          show: true,
          desc: '去微信粘贴'
        },
        {
          id: 2,
          icon: require('../../assets/image/invite/pyq.png'),
          name: '朋友圈'
        },
        {
          id: 3,
          icon: require('../../assets/image/invite/dy.png'),
          name: '抖音好友',
          show: true,
          desc: '去抖音粘贴'
        },
        {
          id: 4,
          icon: require('../../assets/image/invite/qr.png'),
          name: '分享二维码'
        },
        {
          id: 5,
          icon: require('../../assets/image/invite/link.png'),
          name: '复制链接'
        }
      ],
      bgColor: '#4ae44a',
      configData: {
        rule: '',
        code: '',
        coin: 0
      },
      staticData: {
        today_earned_coin: 0,
        today_invite_count: 0,
        total_earned_coin: 0,
        total_invite_count: 0
      },
      shareData: {
        share: true,
        msg: '立即分享赚默往币'
      },
      recordList: [],
      page: 1,
      size: 20
    }
  },
  mounted () {
    window.addEventListener('online', () => {
      if (!this.finished) this.onRefresh(true)
    })
    window.onload = () => {
      console.log(window.navigator.userAgent)
      if (!window.webkit) {
        this.nativeBridge.sendMessage('getStatusNavBarToApp').then(res => {
          if (res.code === 200) {
            this.paddingTop = res.data.statusBar / window.devicePixelRatio
          }
        })
      }
      this.nativeBridge.sendMessage('getUserTokenToApp').then(async res => {
        if (res.code === 200) {
          window.$userToken = res.data.token
          await this.inviteConfig()
          await this.shareConfig()
          await this.inviteData()
          await this.inviteRecord()
        }
      })
    }
  },
  methods: {
    onRefresh (unRefresh = false) {
      this.autoLoadDisabled = true
      this.page = 1
      this.recordList = []
      this.finished = false
      this.finishedLoading = false
      const refreshOptions = { skipToastOnStatus0: true }
      setTimeout(async () => {
        try {
          await Promise.all([
            this.inviteConfig(() => this.shareConfig(refreshOptions), refreshOptions),
            this.inviteData(refreshOptions),
            this.inviteRecord(refreshOptions)
          ])
          if (!unRefresh) Toast('刷新成功')
        } catch (err) {
          this.loading = false
          this.error = true
          this.finishedLoading = true
          const isStatus0 = err && err.request && err.request.status === 0
          const isNetworkError = (err && err.code === 'ERR_NETWORK') || (err && err.message === 'Network Error')
          if (isStatus0 || isNetworkError) {
            Toast('网络异常，请稍后重试')
          } else {
            Toast((err && err.msg) || (err && err.message) || '刷新失败')
          }
        } finally {
          this.autoLoadDisabled = false
          this.refreshLoading = false
        }
      }, 500)
    },
    onLoad () {
      if (this.autoLoadDisabled) {
        this.loading = false
        return
      }
      this.error = false
      this.inviteRecord()
    },
    shareConfig (options = {}) {
      return inviteApi.inviteShare(undefined, options).then(res => {
        if (res.code !== 200) {
          this.shareData = {
            share: false,
            msg: res.msg
          }
        }
      })
    },
    inviteConfig (callback, options = {}) {
      return inviteApi.inviteConfig(undefined, options).then(res => {
        if (res.code === 200) {
          this.configData = {
            rule: res.data.invite_rules,
            code: res.data.my_invitation_code,
            coin: res.data.reward_per_invite
          }
          if (this.shareData.share) {
            this.shareData = res.data.activity_switch === 1 ? { share: true, msg: '立即分享赚默往币' } : {
              share: false,
              msg: '来晚了！活动已结束了～'
            }
          }
          callback && callback(options)
        } else {
          return Promise.reject({ msg: res.msg })
        }
      }).catch(err => {
        return Promise.reject(err)
      })
    },
    inviteData (options = {}) {
      return inviteApi.inviteData(undefined, options).then(res => {
        if (res.code !== 200) {
          return Promise.reject({ msg: res.msg })
        }
        this.staticData = res.data
      }).catch(err => {
        return Promise.reject(err)
      })
    },
    inviteRecord (options = {}) {
      return inviteApi.inviteRecord({ page: this.page, page_size: this.size }, options).then(res => {
        if (res.code === 200) {
          const list = res.data.records || []
          this.recordList = this.recordList.concat(list)
          this.page++
          this.loading = false
          this.error = false
          if (list.length < this.size) {
            this.finished = true
          }
          this.finishedLoading = true
        } else {
          this.error = true
          return Promise.reject({ msg: res.msg })
        }
      }).catch(err => {
        this.error = true
        return Promise.reject(err)
      })
    },
    openRule (show) {
      this.showRule = show
      if (show) {
        this.inviteConfig()
        window.location.hash = 1
      } else {
        window.history.back()
      }
    },
    scroll (e) {
      this.bgColor = this.interpolateColor('#4ae44a', '#98e456', (e.target.scrollTop / 200) > 1 ? 1 : (e.target.scrollTop / 200))
    },
    interpolateColor (color1, color2, factor) {
      const hex = color => color.replace('#', '')
      const c1 = hex(color1)
      const c2 = hex(color2)

      const r1 = parseInt(c1.substring(0, 2), 16)
      const g1 = parseInt(c1.substring(2, 4), 16)
      const b1 = parseInt(c1.substring(4, 6), 16)

      const r2 = parseInt(c2.substring(0, 2), 16)
      const g2 = parseInt(c2.substring(2, 4), 16)
      const b2 = parseInt(c2.substring(4, 6), 16)

      const r = Math.round(r1 + (r2 - r1) * factor)
      const g = Math.round(g1 + (g2 - g1) * factor)
      const b = Math.round(b1 + (b2 - b1) * factor)

      return `rgb(${r}, ${g}, ${b})`
    },
    shareBtn () {
      if (this.shareData.share) {
        this.shareConfig(() => {
          this.showShare = true
        })
      }
    },
    shareMethods (type, e) {
      this.showShare = false
      if ([1, 2, 3].includes(type)) {
        this.nativeBridge.sendMessage('shareInfoToApp', {
          type: type,
          title: '默往-和重要的人聊重要的事',
          subTitle: type === 3 ? '' : '想和你的密友说悄悄话说重要的事就用默往，私密又安全！点击立即下载',
          icon: 'https://okimg.mostonetech.top/admin/pic/a1b2d15ec12911f0aa0a88d7f679e379.png',
          link: 'https://www.mowangim.com'
        })
      } else if (type === 4) {
        this.showQrcode = true
      } else if (type === 5) {
        this.copyText(e, '默往APP下载链接：https://www.mowangim.com/，点击下载和我一起探索默往吧', false)
        this.showPaster = true
      }
    },
    openOtherToApp (id) {
      this.nativeBridge.sendMessage('openOtherToApp', {
        type: id
      }).then(res => {
        this.showPaster = false
      })
    },
    saveImage () {
      const element = document.getElementById('qrcodeImg')
      Toast.loading({
        message: '保存中...',
        forbidClick: true,
        className: 'top-index'
      })
      this.domToCanvas(element).then(canvas => {
        const dataURL = canvas.toDataURL('image/png')
        this.nativeBridge.sendMessage('saveImageToApp', { imageData: dataURL.replace('data:image/png;base64,', '') }).then(res => {
          this.showQrcode = false
          if (res.code === 200) {
            Toast('保存成功')
          } else {
            Toast('保存失败')
          }
        })
      })
    },
    async domToCanvas (domElement) {
      try {
        const canvas = await html2canvas(domElement, {
          // 配置选项
          scale: window.devicePixelRatio * 2, // 缩放比例，提高清晰度
          useCORS: true, // 允许跨域图片
          allowTaint: true, // 允许污染图片
          logging: false // 关闭日志
        })

        return canvas
      } catch (error) {
        console.error('转换失败:', error)
      }
    },
    copyText (e, text, tip = true) {
      handleClipboard(text, e, tip)
    },
    closeWebview (e) {
      this.nativeBridge.sendMessage('quitWebView')
    },
    formatTime (time, format = 'YYYY-MM-DD HH:mm:ss') {
      // 处理不同类型的时间参数
      let date
      if (time instanceof Date) {
        date = time
      } else if (typeof time === 'number') {
        // 时间戳（判断是秒还是毫秒）
        date = time.toString().length === 10 ? new Date(time * 1000) : new Date(time)
      } else if (typeof time === 'string') {
        date = new Date(time.replace(/-/g, '/')) // 解决iOS兼容性问题
      } else {
        date = new Date()
      }

      // 验证日期是否有效
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', time)
        return 'Invalid Date'
      }

      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
      const millisecond = date.getMilliseconds()
      const week = date.getDay()

      // 星期映射
      const weekMap = ['日', '一', '二', '三', '四', '五', '六']

      // 格式化规则映射
      const formatMap = {
        'YYYY': year.toString(),
        'YY': year.toString().slice(-2),
        'MM': month.toString().padStart(2, '0'),
        'M': month.toString(),
        'DD': day.toString().padStart(2, '0'),
        'D': day.toString(),
        'HH': hour.toString().padStart(2, '0'),
        'H': hour.toString(),
        'hh': (hour % 12 || 12).toString().padStart(2, '0'),
        'h': (hour % 12 || 12).toString(),
        'mm': minute.toString().padStart(2, '0'),
        'm': minute.toString(),
        'ss': second.toString().padStart(2, '0'),
        's': second.toString(),
        'SSS': millisecond.toString().padStart(3, '0'),
        'A': hour < 12 ? 'AM' : 'PM',
        'a': hour < 12 ? 'am' : 'pm',
        'dddd': '星期' + weekMap[week],
        'ddd': '周' + weekMap[week],
        'WW': weekMap[week]
      }

      // 替换格式化字符串
      return format.replace(/YYYY|YY|MM|M|DD|D|HH|H|hh|h|mm|m|ss|s|SSS|A|a|dddd|ddd|WW/g, match => {
        return formatMap[match] || match
      })
    },
    ontouchstart (e) {
      this.x = e.touches[0].clientX
      this.y = e.touches[0].clientY
    },
    ontouchend (e) {
      const x = e.changedTouches[0].clientX - this.x
      const y = Math.abs(e.changedTouches[0].clientY - this.y)
      if (x > document.body.clientWidth * 0.3 && y < document.body.clientWidth * 0.3) {
        if (this.showRule) this.openRule(false)
        else this.closeWebview()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/style.scss";
.app-container-page {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  //background: linear-gradient(to bottom, #39e448 30%, #b0e458 40%);
  background-color: #b0e458;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
  padding-top: calc(constant(safe-area-inset-top, 44px) - 20px) !important;
  padding-top: calc(env(safe-area-inset-top, 44px) - 20px) !important;

  .invite-page {
    width: 100%;
    background-image: url("../../assets/image/invite/header-bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;
    min-height: 100vh;
    padding-top: px2rem(670);
    padding-bottom: px2rem(180);
    box-sizing: border-box;
  }

  .navbar {
    width: 100%;
    height: px2rem(100);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-size: px2rem(32);
    position: fixed;
    top: 0;
    z-index: 9;

    &.ios {
      //padding-top: 44px!important;
      padding-top: constant(safe-area-inset-top, 44px) !important;
      padding-top: env(safe-area-inset-top, 44px) !important;
    }

    .navbar-back {
      width: px2rem(100);
      height: px2rem(100);
      background-image: url("../../assets/image/invite/back.svg");
      background-repeat: no-repeat;
      background-position: center;
    }

    .navbar-menu {
      width: px2rem(100);
      height: px2rem(100);
      display: flex;
      align-items: center;
      font-size: px2rem(30);
    }
  }

  .notice-icon {
    width: px2rem(178);
    height: px2rem(221);
    background-image: url("../../assets/image/invite/header-notice.png");
    background-size: 100% 100%;
    position: absolute;
    top: px2rem(220);
    z-index: 1;
  }

  .bar-icon {
    min-width: px2rem(590);
    height: px2rem(81);
    background-image: url("../../assets/image/invite/header-bar.png");
    background-size: 100% 100%;
    position: absolute;
    top: px2rem(280);
    left: px2rem(100);
    padding-right: px2rem(10);

    div {
      font-size: px2rem(32);
      transform: rotate(-2.5deg);
      color: transparent;
      text-indent: px2rem(60);
    }
  }

  .bar-msg {
    position: absolute;
    top: px2rem(300);
    left: px2rem(160);
    color: #fff;
    font-size: px2rem(32);
    transform: rotate(-2.5deg);

    span {
      color: gold;
    }
  }

  .static-num {
    width: px2rem(343*2);
    height: px2rem(217*2);
    border-radius: px2rem(32);
    background: linear-gradient(166.43deg, #FFFFFF 9.72%, #F1FFD5 84.07%);
    margin: 0 auto;
    border: 1px solid #DFFFB7;
    position: relative;

    .row-divider {
      width: px2rem(622);
      height: 1px;
      background: linear-gradient(90deg, #FEFFFB 0%, #2DC119 25%, #2DC119 82.21%, #FEFFFB 100%);
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%) scaleY(0.5);
    }

    .column-divider {
      width: 1px;
      height: px2rem(310);
      background: linear-gradient(0deg, #FEFFFB 0%, #2DC119 25%, #2DC119 82.21%, #FEFFFB 100%);
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%) scaleX(1);
    }

    .invite-row {
      display: flex;
      font-size: px2rem(28);

      .invite-item {
        width: px2rem(400);
        height: px2rem(175);
        @include centerV();
        color: #2DC119;

        .label {
          color: black;
        }

        strong {
          font-size: px2rem(48);
          vertical-align: bottom;
          margin: 0 px2rem(5);
          line-height: 0;
        }

        .invite-num {
          font-size: px2rem(24);
          @include center();
          margin-bottom: px2rem(10);

          img {
            margin-bottom: px2rem(5);
          }

          &.txt {
            margin-bottom: px2rem(16);
            //vertical-align: bottom;
            //line-height: 0;
            //align-items: flex-end;
          }
        }
      }
    }

    .invite-code {
      width: 100%;
      height: px2rem(70);
      font-size: px2rem(28);
      color: #2DC119;
      @include center();
      box-sizing: border-box;
      font-weight: bold;

      .copy {
        width: px2rem(96);
        height: px2rem(48);
        background: #2DC119;
        color: #fff;
        @include centerV();
        border-radius: px2rem(24);
        margin: 0 px2rem(24);
      }
    }
  }

  .share-step {
    width: px2rem(343*2);
    height: px2rem(133*2);
    border-radius: px2rem(32);
    background: linear-gradient(166.43deg, #FFFFFF 9.72%, #F1FFD5 84.07%);
    margin: px2rem(32) auto;
    border: 1px solid #DFFFB7;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    box-sizing: border-box;
    padding: px2rem(32) px2rem(10);

    .item {
      @include centerV();
      font-size: px2rem(24);
      text-align: center;
      width: px2rem(190);
      flex-shrink: 0;

      .img {
        width: px2rem(100);
        height: px2rem(100);
        background-image: url("../../assets/image/invite/share.svg");
        background-size: 100% 100%;
        margin-bottom: px2rem(20);
      }

      &:nth-child(3) {
        .img {
          background-image: url("../../assets/image/invite/download.svg");
        }
      }

      &:nth-child(5) {
        .img {
          background-image: url("../../assets/image/invite/mw.svg");
        }
      }
    }

    .arrow-item {
      display: flex;
      align-items: center;
      height: px2rem(100);

      .arrow {
        width: px2rem(48);
        height: px2rem(48);
        background-image: url("../../assets/image/invite/arrow.svg");
        background-size: 100% 100%;
      }
    }
  }

  .record-container {
    width: px2rem(343*2);
    min-height: px2rem(343*2);
    border-radius: px2rem(32);
    background: linear-gradient(166.43deg, #FFFFFF 9.72%, #F1FFD5 84.07%);
    margin: px2rem(0) auto;
    border: 1px solid #DFFFB7;

    .title {
      height: px2rem(72);
      font-size: px2rem(32);
      color: #2DC119;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      font-weight: bold;
    }

    .record-list {
      padding: 0 px2rem(32);

      .user-item {
        display: flex;
        font-size: px2rem(28);
        padding: px2rem(20) 0;
        align-items: center;

        .avatar {
          width: px2rem(80);
          height: px2rem(80);
          background: #fff;
          border-radius: 50%;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .user-info {
          flex: 1;
          margin: 0 px2rem(20);

          .nickname {
            color: #2DC119;
            font-weight: bold;
            width: px2rem(400);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .time {
            color: #B6B7BA;
          }
        }

        .value {
          font-size: px2rem(32);
          color: #2DC119;
          font-weight: bold;
        }
      }
    }

    .empty {
      @include centerV();
      font-size: px2rem(28);
      color: #B6B7BA;
      height: px2rem(500);

      img {
        width: px2rem(300);
      }
    }

  }

  .share-button {
    width: px2rem(345*2);
    height: px2rem(50*2);
    background: #2DC119;
    color: #fff;
    @include centerV();
    border-radius: px2rem(50);
    font-size: px2rem(32);
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    bottom: px2rem(50);

    &.disabled {
      background: #DBDBDD;
      color: #B6B7BA;
    }
  }

  .share-container {
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #fff;
    padding: px2rem(48);
    box-sizing: border-box;
    border-top-left-radius: px2rem(32);
    border-top-right-radius: px2rem(32);

    .title {
      font-size: px2rem(28);
      text-align: center;

      span {
        color: #2DC119;
      }
    }

    .cancel-button {
      width: px2rem(620);
      height: px2rem(100);
      background: #F7F7F8;
      font-size: px2rem(32);
      @include center();
      border-radius: px2rem(50);
      color: #6d6f76;
      margin: 0 auto;

    }
  }

  .platform-list {
    display: flex;
    justify-content: space-between;
    margin-top: px2rem(46);
    margin-bottom: px2rem(80);

    .item {
      font-size: px2rem(24);
      @include centerV();
      justify-content: space-between;

      .icon {
        width: px2rem(100);
        height: px2rem(100);
        background-size: 100% 100%;
      }
    }
  }

  .paster-container {
    width: px2rem(600);
    height: px2rem(412);
    background: #FFFFFF;
    border-radius: px2rem(32);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: px2rem(30) px2rem(40);
    box-sizing: border-box;

    .title {
      @include center();
      font-size: px2rem(32);
      font-weight: bold;

      i {
        width: px2rem(48);
        height: px2rem(48);
        background-image: url("../../assets/image/invite/right.png");
        background-size: 100% 100%;
        margin: 0 px2rem(4);
      }
    }

    .content {
      width: px2rem(520);
      height: px2rem(108);
      border-radius: px2rem(12);
      background: #eee;
      color: #6D6F76;
      font-size: px2rem(24);
      padding: px2rem(20);
      box-sizing: border-box;
      margin-top: px2rem(28);
      margin-bottom: px2rem(16);
    }

    .paster-platform {
      width: px2rem(360);
      margin: 0 auto;

      .item {
        @include centerV();
      }
    }
  }

  .qrcode-container {
    width: px2rem(600);
    height: px2rem(488*2);
    background: #FFFFFF;
    border-radius: px2rem(32);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: px2rem(0) px2rem(40);
    box-sizing: border-box;

    .title {
      text-align: center;
      font-weight: bold;
      font-size: px2rem(32);
      padding: px2rem(48) 0;
    }

    .qrcode-wrap {
      width: 100%;
      height: px2rem(640);
      //background-image: url("../../assets/image/invite/qrcode-bg.png");
      //background-size: 100% 100%;
      position: relative;
      font-size: 0;

      .qrcode {
        width: px2rem(400);
        height: px2rem(400);
        position: absolute;
        left: px2rem(60);
        top: px2rem(165);
        box-sizing: border-box;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .save-button {
      width: 100%;
      height: px2rem(88);
      font-size: px2rem(32);
      background: #2DC119;
      color: #fff;
      @include centerV();
      border-radius: px2rem(44);
      margin-top: px2rem(40);
    }

    .close {
      width: px2rem(48);
      height: px2rem(48);
      background-image: url("../../assets/image/invite/close.svg");
      background-size: 100% 100%;
      position: absolute;
      bottom: px2rem(-80);
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .rule-page {
    width: 100%;
    height: 100vh;
    background: #FFFFFF;
    position: fixed;
    top: 0;
    z-index: 9;
    overflow-y: auto;

    .navbar {
      background: #fff;

      .navbar-title {
        color: black;
      }

      .navbar-back {
        background-image: url("../../assets/image/invite/back_black.svg");
      }
    }

    .rule-container {
      width: 100%;
      box-sizing: border-box;
      padding: px2rem(100) px2rem(20) px2rem(20) px2rem(20);
      font-size: px2rem(28);

      &.ios {
        padding-top: calc(1.33333rem + constant(safe-area-inset-top)) !important;
        padding-top: calc(1.33333rem + env(safe-area-inset-top)) !important;
      }

      img {
        max-width: 100%;
      }
    }
  }
}

</style>

<style>
html, body, #app {
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
}
.rule-container ul,.rule-container ol {
  padding-left: 20px;
}
.rule-container ul li {
  list-style: disc!important;
}

.rule-container ol li {
  list-style: decimal;
}
.top-index {
  z-index: 999999;
}
</style>
